import * as KYC from '@/kyc/routes'

import Property from '@/properties/Property.vue'

import PortfolioPage from '@/portfolio/Page.vue'
import PerformanceTab from '@/portfolio/PerformanceTab.vue'
import MyPropertiesTab from '@/portfolio/MyPropertiesTab.vue'
import DividendsTab from '@/portfolio/DividendsTab.vue'

import Contact from '@/views/Contact.vue'
import AccountPage from '@/account/AccountPage.vue'
import Explore from '@/properties/Explore.vue'
import NotificationsPage from '@/notifications/Page.vue'

import LoginPage from '@/auth/LoginPage.vue'
import WaitListThankYouPage from '@/auth/WaitListPage.vue'
import AuthenticatedWindow from '@/views/AuthenticatedWindow.vue'

import Vue from 'vue'
import VueRouter, { NavigationGuard } from 'vue-router'
import { authService } from '@/auth/service'
import { RMUser } from '@/auth/api'
import { first } from 'rxjs/operators'
Vue.use(VueRouter)

async function _getUser(): Promise<RMUser | null> {
  const service = await authService()
  return service.user.pipe(first()).toPromise()
}

const authenticatedOnly: NavigationGuard<Vue> = async (to, from, next) => {
  const user = await _getUser()
  console.log('authenticatedOnly, user:', user)
  if (user == null || user.isAnonymous) {
    next('/login')
  } else if (user.waitListed) {
    next('/waitList')
  } else {
    next()
  }
}

const anonymousOnly: NavigationGuard<Vue> = async (to, from, next) => {
  const service = await authService()
  const loggedIn = await service.loggedIn
  console.log('anonymousOnly, loggedIn:', loggedIn)
  if (loggedIn) {
    console.log('go to /explore')
    next({ name: 'explore' })
  } else {
    console.log('go to ', to)
    next()
  }
}

export const router = new VueRouter({
  // mode: 'history',
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    // temporary
    {
      path: '/',
      name: 'home',
      component: LoginPage,
      beforeEnter: anonymousOnly

    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      beforeEnter: anonymousOnly
    },
    {
      path: '/waitList',
      name: 'waitList',
      component: WaitListThankYouPage
    },
    ...KYC.routes,
    {
      path: '/main',
      component: AuthenticatedWindow,
      children: [
        {
          path: '',
          name: 'explore',
          component: Explore,
          beforeEnter: authenticatedOnly
        },
        {
          path: '/property/:propertyID',
          name: 'property',
          component: Property,
          props: true,
          beforeEnter: authenticatedOnly
        },
        {
          path: '/portfolio',
          component: PortfolioPage,
          beforeEnter: authenticatedOnly,

          children: [
            {
              path: '',
              // name: "porfolio.performance",
              component: PerformanceTab
            },
            {
              path: 'properties',
              // name: "porfolio.properties",
              component: MyPropertiesTab
            },
            {
              path: 'dividends',
              // name: "porfolio.properties",
              component: DividendsTab
            }
          ]
        },
        {
          path: '/notifications',
          name: 'notifications',
          component: NotificationsPage,
          beforeEnter: authenticatedOnly
        },
        {
          path: '/contact',
          name: 'contact',
          component: Contact,
          beforeEnter: authenticatedOnly
        },
        {
          path: '/account',
          name: 'account',
          component: AccountPage,
          beforeEnter: authenticatedOnly
        }
      ]
    }

  ]
})

export default router
